import React from 'react'
import { FormattedMessage } from 'react-intl';
import "./styles/HeaderFilmSolutionsLink.scss";
import { MEDICAL_SOLUTIONS_URL } from './constants';

const HeaderFilmSolutionsLink = () => {
  return (
    <a 
      href={MEDICAL_SOLUTIONS_URL}
      className="header-market-segment__title header-healthcare-solutions-link"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FormattedMessage 
          id="HeaderProductsDropdown.healthcareSolutions"
          defaultMessage="Healthcare Solutions" 
          values={{
            br: <br />
          }} />
    </a>
  )
}

export default HeaderFilmSolutionsLink